import React from "react"
import PropTypes from "prop-types"

// Utilities
import kebabCase from "lodash/kebabCase"

// Components
import { Helmet } from "react-helmet"
import { Link, graphql } from "gatsby"
import Layout from "../components/page/layout"

import { Button } from "theme-ui"

const TagsPage = ({
  data: {
    allMdx: { group },
    site: {
      siteMetadata: { title },
    },
  },
}) => (
  <Layout>
    {" "}
    <div>
      <Helmet title={title} />

      <h1 className="tagHeader">Tags</h1>
      <div>
        {group
          .sort((a, b) => b.totalCount - a.totalCount)
          .map(tag => (
            <Button className="squareTagButton" key={tag.fieldValue}>
              {" "}
              <Link to={`/tags/${kebabCase(tag.fieldValue)}/`}>
                <span className="squareTagContent">
                  {" "}
                  {tag.fieldValue} ({tag.totalCount})
                </span>
              </Link>
            </Button>
          ))}
      </div>
    </div>
  </Layout>
)

TagsPage.propTypes = {
  data: PropTypes.shape({
    allMdx: PropTypes.shape({
      group: PropTypes.arrayOf(
        PropTypes.shape({
          fieldValue: PropTypes.string.isRequired,
          totalCount: PropTypes.number.isRequired,
        }).isRequired
      ),
    }),
    site: PropTypes.shape({
      siteMetadata: PropTypes.shape({
        title: PropTypes.string.isRequired,
      }),
    }),
  }),
}

export default TagsPage

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMdx(limit: 2000) {
      group(field: frontmatter___tags) {
        fieldValue
        totalCount
      }
    }
  }
`
